// extracted by mini-css-extract-plugin
export default {"content":"AuthContentHeader_content__QjGkm"};